/* eslint-disable react-hooks/exhaustive-deps */
import { Box, Modal } from "@mui/material";

import { useCallback, useEffect, useRef, useState } from "react";
import ReactPlayer from "react-player";
import { useParams } from "react-router-dom";

import _cookiesChunked from "../../../../../../shared/utils/_cookiesChunked";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import PreviewMarker from "../../partials/PreviewMarker";
import { useRegisterView } from "../../../../../../features/quadrants/api/registerView";
import { useQuadrantViewedStatus } from "../../../../../../features/quadrants/api/getQuadrantViewedStatus";
import { useWaterMark } from "../../../../../../features/quadrants/hooks/useWaterMark";
import { cn } from "../../../../../../shared/utils/cn";

function VideoContent({
  app,
  contentId,
  mandatory,
  sx = {},
  url,
  hideControls,
  children,
  isEditing,
  auth,
  enrollment,
  enrollmentId: enrollmentIdProp,
  chapters,
  isConfidential,
  ...props
}) {
  const waterMarkCN = useWaterMark();

  const { currentChapter } = useParams();
  const defaultTime = 2 * 1000 * 60; // 2 minutos

  const [isOpen, setIsOpen] = useState(false);

  const videoData = _cookiesChunked.getItem("params");
  window.pandascripttag = window.pandascripttag || [];
  const playerRef = useRef(null);

  const registerViewMutation = useRegisterView({});

  const quadrantViewedQuery = useQuadrantViewedStatus({
    chapterId: currentChapter,
    enrollmentId: enrollment?.MATRICULAID,
    quadrantId: contentId,
  });

  // Usa o enrollment do Redux quando disponível, senão usa o prop recebido pela árvore de componentes
  const effectiveEnrollmentId = enrollment?.MATRICULAID ?? enrollmentIdProp;

  const handleEnded = () => {
    if (!isEditing && mandatory === "S" && !quadrantViewedQuery.data?.viewed) {
      registerViewMutation.mutate({
        enrollmentId: effectiveEnrollmentId,
        chapterId: currentChapter,
        quadrantId: contentId,
      });
    }
  };

  const isYoutube = url?.search(/youtu/) > -1;
  var youtubeHiddenControlsURL = new URL(url || "http://teste.com");

  youtubeHiddenControlsURL.searchParams.set("controls", 0);
  const isPandaVideo = url?.search(/pandavideo/) > -1;

  // Extrai o ID do vídeo da URL usando URLSearchParams para evitar falhas
  // quando a URL contém outros parâmetros após o ID (ex: ?v=abc123&quality=720)
  const getPandaVideoId = (videoUrl) => {
    try {
      return new URL(videoUrl || "").searchParams.get("v");
    } catch {
      return videoUrl?.split("v=")?.pop();
    }
  };

  const onReceiveMessage = useCallback(
    (event) => {
      const { data } = event;
      const thisVideoId = getPandaVideoId(url);

      switch (data.message) {
        case "panda_play":
          if (app?.params.PAUSAR_VIDEO_PERIODICAMENTE !== 0) {
            setTimeout(
              () => {
                playerRef.current?.pause?.();
                setIsOpen(true);
              },
              videoData?.TEMPO_PAUSE_VIDEO ||
                app?.params.PAUSAR_VIDEO_PERIODICAMENTE * 1000 * 60 ||
                defaultTime,
            );
          }
          break;
        case "panda_allData":
          break;
        case "panda_progress":
          break;
        case "panda_timeupdate":
          break;
        case "panda_ended":
          // Chama handleEnded se o ID do vídeo bater ou se a Panda não enviar o ID no evento
          if (!data?.video || thisVideoId === data?.video) {
            handleEnded();
          }
          break;
        default:
        // console.log(data.message);
      }
    },
    [handleEnded, url],
  );

  useEffect(() => {
    if (isPandaVideo && window.PandaPlayer) {
      try {
        playerRef.current = new window.PandaPlayer("panda-video", {
          onReady: () => {},
          onError: () => {},
        });
      } catch (e) {
        // PandaPlayer failed to initialize (e.g. iframe not ready)
      }
    }
    return () => {
      playerRef.current = null;
    };
  }, [isPandaVideo]);

  useEffect(() => {
    const pauseFn = () => playerRef.current?.pause?.();
    window.addEventListener("message", onReceiveMessage);
    if (isPandaVideo) {
      window.addEventListener("blur", pauseFn);
    }
    return () => {
      window.removeEventListener("message", onReceiveMessage);
      if (isPandaVideo) {
        window.removeEventListener("blur", pauseFn);
      }
    };
  }, [isPandaVideo, onReceiveMessage, mandatory]);

  const basicControls = [
    "play-large", //botão de play no meio da tela
    "play", //botão de play/pause no canto inferior esquerdo
    "volume", //controle de volume
    "captions", //controle de legendas
    "pip", //ativar/desativar player in picture
    "fullscreen", //ativar/desativar tela cheia
    "settings", //controle de qualidade (360p, 480p, 720p, 1080p, etc...), velocidade e report de erro — sempre visível
  ];

  const additionalControls = [
    "progress", //barra de progresso (tempo) do video — oculta quando hideControls=true (impede avanço/seek)
    "current-time", //indicador do tempo total e atual do video — oculto quando hideControls=true
  ];

  const allControls = [...basicControls, ...additionalControls]?.join(",");

  const playControls = basicControls.join(",");

  return (
    <>
      {isPandaVideo ? (
        <Box
          sx={{ width: "100%", height: "100%", position: "relative" }}
          className={cn(
            "PandaVideo-Root",
            isConfidential && waterMarkCN.WatermarkAbsolute,
            isConfidential &&
              "after:pointer-events-none after:top-0 after:absolute",
          )}
        >
          <iframe
            key="panda-video"
            id="panda-video"
            className="PandaVideo-Iframe aspect-video h-full max-h-full max-w-full ml-auto mr-auto object-cover"
            // className="h-full w-full"
            title="Panda"
            src={url + `&controls=${hideControls ? playControls : allControls}`}
            allowFullScreen="true"
          />
          {!isEditing && mandatory === "S" && (
            <Box
              sx={{
                position: "absolute",
                top: "0",
              }}
            >
              <PreviewMarker
                viewed={quadrantViewedQuery.data?.viewed}
                TooltipValue={"Assista o vídeo até o final"}
              />
            </Box>
          )}
        </Box>
      ) : (
        <Box
          sx={{
            aspectRatio: "16 / 9",
            width: "100%",
            height: "auto",
            iframe: { width: "100%", height: "100%" },
            position: "relative",
          }}
          className={cn(
            isConfidential && waterMarkCN.WatermarkAbsolute,
            isConfidential &&
              "after:pointer-events-none after:top-0 after:absolute",
          )}
        >
          {!isEditing && mandatory === "S" && (
            <Box
              sx={{
                position: "absolute",
                top: "0",
              }}
            >
              <PreviewMarker
                viewed={quadrantViewedQuery.data?.viewed}
                TooltipValue={
                  "A visualização desse vídeo será contabilizada ao final do vídeo"
                }
              />
            </Box>
          )}
          {isYoutube && hideControls ? (
            <ReactPlayer
              url={youtubeHiddenControlsURL.href}
              width="100%"
              height="100%"
              // controls={!hideControls}
              onEnded={handleEnded}
              config={{
                playerVars: {
                  playinline: 1,
                },
              }}
            />
          ) : (
            <ReactPlayer
              url={url}
              width="100%"
              height="100%"
              controls
              onEnded={handleEnded}
              config={{
                playerVars: {
                  playinline: 1,
                },
              }}
            />
          )}
        </Box>
      )}

      <Modal
        open={isOpen}
        onClose={() => setIsOpen(false)}
        className="w-screen	h-screen"
      >
        <div className="bg-white absolute translate-y-1/2 translate-x-1/2 bottom-1/2 right-1/2 w-full mq-900:w-1/2 h-screen mq-900:h-1/2 rounded shadow flex flex-col justify-around items-center">
          <h1 className="text-xl">Ainda está aqui?</h1>
          <button
            className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded"
            onClick={() => setIsOpen(false)}
          >
            Continuar
          </button>
        </div>
      </Modal>
    </>
  );
}

const mapStateToProps = (state) => ({
  auth: state.auth,
  enrollment: state.course?.enrollment,
  chapters: state.course?.chapters,
  app: state.app,
});

const mapDispatchToProps = (dispatch) => bindActionCreators({}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(VideoContent);
